import React from 'react';
import ReactDOM from 'react-dom';
import ReviewStars from '../../components/modules/reviews/ReviewStars.jsx';

const ratings = document.querySelectorAll(
    '.rating.aggregateRating.product-card'
);
if (ratings !== null) {
    for (let i = 0; i < ratings.length; i++) {
        ReactDOM.render(
            <ReviewStars
                maxRating={5}
                average={Number(ratings[i].dataset.rating)}
            />,
            ratings[i]
        );
    }
}
